import React from 'react';

/**
 * react-markdown element overrides shared by the extension detail panels.
 * Tables get Blueprint's html-table styling (the app has no bare table CSS) and
 * a horizontal scroll wrapper so a wide table cannot stretch the panel.
 */
const markdownComponents = {
    // eslint-disable-next-line no-unused-vars
    table: ({ node, ...props }) => (
        <div style={{ overflowX: 'auto', marginBottom: 10 }}>
            <table className="bp5-html-table bp5-html-table-bordered bp5-html-table-condensed" {...props} />
        </div>
    ),
};

export default markdownComponents;
